

import React from 'react';

const findWithRegex = (regex, contentBlock, callback) => {
  const text = contentBlock.getText();
  let matchArr;
  let start;

  // eslint-disable-next-line no-cond-assign
  while ((matchArr = regex.exec(text)) !== null) {
    if (matchArr) {
      start = matchArr.index;
      callback(start, start + matchArr[0].length);
    }
  }
};


const handlePlaceholderStrategy = (contentBlock, callback) => {
  findWithRegex(/<Recipient Name>|<Company Name>/ig, contentBlock, callback);
};

const HandlePlaceholder = (props) => {
  const { children } = props;

  return (
    <span style={{ color: '#27BBA1' }}>
      {children}
    </span>);

};

export const decorators = [
{
  strategy: handlePlaceholderStrategy,
  component: HandlePlaceholder
}];